var _circle, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var Svg1 = function Svg1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 274 274"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: 137,
    r: 137,
    fill: "url(#1_svg__a)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "1_svg__b",
    width: 119,
    height: 119,
    x: 80,
    y: 68,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M80.334 68.334H199V187H80.334z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#1_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FEF4E2",
    d: "M196.932 127.604c0 31.695-25.694 57.39-57.39 57.39s-57.39-25.695-57.39-57.39c0-31.696 25.694-57.39 57.39-57.39s57.39 25.694 57.39 57.39"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3E4B5A",
    d: "M138.921 87.345c-8.666 0-15.69 7.025-15.69 15.69v6.494c1.049-.972 2.541-1.501 3.997-1.306v-.782a1.07 1.07 0 0 1 1.146-1.066c6.066.436 12.24-1.492 16.907-4.541a1.07 1.07 0 0 1 1.367.167c3.991 4.289 3.967 4.123 3.967 4.683v1.536c1.596-.24 3.012.254 3.995 1.168v-6.353c0-8.665-7.024-15.69-15.689-15.69"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M128.907 103.035c0-7.696 5.542-14.093 12.852-15.429a16 16 0 0 0-2.838-.26c-8.665 0-15.69 7.023-15.69 15.689v6.493c1.049-.972 2.541-1.5 3.997-1.305v-.782c0-.622.531-1.113 1.146-1.066.178.013.355.017.533.025z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBEAB",
    d: "M137.129 130.662a1.64 1.64 0 0 0 1.05-1.533v-2.22c-2.16-.146-4.074-.807-5.675-1.829v4.9c0 .438-.176.846-.469 1.147z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBEAB",
    d: "M130.378 134.391c5.001 5.313 12.071 5.313 17.072 0l1.775-1.887-2.611-1.011a1.56 1.56 0 0 1-.998-1.457v-5.13a11.46 11.46 0 0 1-6.528 2.034c-2.535 0-4.762-.696-6.584-1.86v4.9c0 .679-.417 1.288-1.05 1.533l-2.772 1.075z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7AF9F",
    d: "M138.179 126.909c-2.16-.146-4.074-.807-5.675-1.83v4.901c0 .679-.417 1.288-1.05 1.533l-2.772 1.075 1.696 1.803c2.298 2.441 5.032 3.757 7.801 3.955z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBEAB",
    d: "M150.381 107.519v8.595q-.001.139-.006.278c3.041.46 5.656-1.737 5.656-4.436 0-2.705-2.617-4.892-5.65-4.437M127.462 116.114v-8.592c-2.648-.353-5.65 1.679-5.65 4.434 0 2.695 2.61 4.897 5.656 4.436q-.004-.14-.006-.278"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7AF9F",
    d: "M154.023 108.322a5.12 5.12 0 0 0-3.642-.803v8.595q-.001.139-.006.278a5.1 5.1 0 0 0 3.648-.803zM127.462 115.59c-1.217-.823-2.009-2.152-2.009-3.634 0-1.451.833-2.701 2.009-3.508v-.926c-2.648-.353-5.65 1.679-5.65 4.434 0 2.695 2.61 4.897 5.656 4.436q-.004-.14-.006-.278z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCDBF",
    d: "M146.648 101.3a1.07 1.07 0 0 0-1.367-.167c-4.667 3.05-10.841 4.977-16.907 4.542a1.07 1.07 0 0 0-1.146 1.065v9.373c0 6.025 4.72 11.527 11.86 11.527 6.356 0 11.527-5.171 11.527-11.527v-10.129c0-.56.024-.395-3.967-4.684"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBEAB",
    d: "M132.903 116.114v-10.535a25 25 0 0 1-4.529.096 1.07 1.07 0 0 0-1.146 1.066v9.373c0 6.024 4.72 11.526 11.86 11.526.945 0 1.863-.117 2.743-.332-5.47-1.271-8.928-6.04-8.928-11.194"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAB331",
    d: "m162.96 137.823-14.079-5.453-1.814 1.928c-4.773 5.071-11.519 5.071-16.291 0l-1.739-1.848-13.858 5.373s-6.415 2.637-6.415 9.95v16.229c0 .824.668 1.492 1.492 1.492h57.639a1.48 1.48 0 0 0 1.48-1.479v-16.242c0-7.313-6.415-9.95-6.415-9.95"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F28230",
    d: "M114.439 164.002v-18.499c0-5.887 4.155-8.743 5.776-9.633l-5.037 1.953s-6.414 2.637-6.414 9.95v16.229c0 .824.668 1.492 1.492 1.492h5.675a1.49 1.49 0 0 1-1.492-1.492"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F28230",
    d: "M121.42 165.494v-15.208a1.738 1.738 0 1 0-3.477 0v15.208zM160.195 165.494v-15.208a1.738 1.738 0 1 0-3.476 0v15.208z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1DD1A1",
    d: "M197.335 167.026c0-9.993-8.101-18.094-18.094-18.094s-18.094 8.101-18.094 18.094 8.101 18.094 18.094 18.094 18.094-8.101 18.094-18.094"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#15BA8B",
    d: "M165.782 167.026c0-9.207 6.879-16.802 15.777-17.941a18 18 0 0 0-2.318-.153c-9.993 0-18.094 8.101-18.094 18.094s8.101 18.094 18.094 18.094c.786 0 1.558-.056 2.318-.153-8.898-1.138-15.777-8.733-15.777-17.941"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M187.836 163.568h-4.342a.795.795 0 0 1-.795-.795v-4.343a.795.795 0 0 0-.795-.795h-5.327a.795.795 0 0 0-.795.795v4.343a.795.795 0 0 1-.795.795h-4.342a.795.795 0 0 0-.795.795v5.327c0 .439.356.795.795.795h4.342c.439 0 .795.356.795.795v4.342c0 .439.356.795.795.795h5.327a.795.795 0 0 0 .795-.795v-4.342c0-.439.356-.795.795-.795h4.342a.795.795 0 0 0 .795-.795v-5.327a.795.795 0 0 0-.795-.795"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M146.572 101.3a1.07 1.07 0 0 0-1.367-.167c-4.668 3.05-10.841 4.977-16.908 4.542a1.07 1.07 0 0 0-1.146 1.065v9.373c0 6.025 4.721 11.527 11.861 11.527 6.355 0 11.526-5.171 11.526-11.527v-10.129c0-.56.024-.395-3.966-4.684"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M150.538 107.519v8.595q-.001.139-.007.278c3.042.46 5.424-1.737 5.424-4.436 0-2.705-2.384-4.892-5.417-4.437M127.152 116.114v-8.592c-2.648-.353-5.417 1.679-5.417 4.434 0 2.695 2.377 4.897 5.423 4.436q-.004-.14-.006-.278"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M138.845 87.345c-8.666 0-15.69 7.025-15.69 15.69v5.793c1.049-.972 2.54-1.5 3.997-1.306v-.782c0-.621.53-1.112 1.146-1.066 6.066.436 12.239-1.492 16.907-4.541a1.07 1.07 0 0 1 1.367.167c3.991 4.29 3.967 4.123 3.967 4.684v1.535c1.596-.24 3.012.254 3.995 1.168v-5.652c0-8.665-7.024-15.69-15.689-15.69M158.38 165.494v-15.208M119.605 165.494v-15.208M197.258 167.026c0-9.993-8.101-18.094-18.094-18.094s-18.094 8.101-18.094 18.094 8.101 18.094 18.094 18.094 18.094-8.101 18.094-18.094"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M187.76 163.568h-4.342a.795.795 0 0 1-.795-.795v-4.343a.795.795 0 0 0-.795-.795h-5.327a.795.795 0 0 0-.795.795v4.343a.795.795 0 0 1-.795.795h-4.343a.795.795 0 0 0-.795.795v5.327c0 .439.356.795.795.795h4.343c.439 0 .795.356.795.795v4.342c0 .439.356.795.795.795h5.327a.795.795 0 0 0 .795-.795v-4.342c0-.439.356-.795.795-.795h4.342a.795.795 0 0 0 .795-.795v-5.327a.795.795 0 0 0-.795-.795M162.883 137.823l-16.346-6.331a1.56 1.56 0 0 1-.997-1.456v-4.43a11.46 11.46 0 0 1-6.528 2.034c-2.535 0-4.762-.696-6.584-1.86v4.2c0 .679-.418 1.288-1.05 1.533l-16.276 6.31s-6.414 2.637-6.414 9.95v16.229c0 .824.668 1.492 1.492 1.492h50.96c.479-5.712 3.609-10.666 8.158-13.632v-4.089c0-7.313-6.415-9.95-6.415-9.95"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M169.298 151.862v-4.089c0-7.313-6.415-9.95-6.415-9.95l-14.079-5.453-1.814 1.928c-4.772 5.071-11.518 5.071-16.291 0l-1.739-1.848-13.858 5.373s-6.414 2.637-6.414 9.95v16.229c0 .824.668 1.492 1.492 1.492h50.959M143.723 184.963a57.1 57.1 0 0 0 21.805-6.05"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M196.838 123.611c-2.082-29.838-26.943-53.398-57.309-53.398-31.731 0-57.454 25.723-57.454 57.454 0 30.413 23.633 55.303 53.536 57.317M190.953 153.306a57.1 57.1 0 0 0 5.882-21.583"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "1_svg__a",
    x1: 137,
    x2: 137,
    y1: 0,
    y2: 274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331",
    stopOpacity: 0
  })))));
};
export default Svg1;